import UserList from "../Views/User/UserList.vue";
import UserCreate from "../Views/User/UserCreate.vue";
import UserEdit from "../Views/User/UserEdit.vue";
import UserProfile from "../Views/User/UserProfile.vue";
import UserShow from "../Views/User/UserShow.vue";
import ManagementTeamList from "../Views/User/ManagementTeamList.vue";
import { MODULES } from "../Constants/modules.js";
import { adminGuard, notStaffOrExternalGuard } from "./guards.js";

export const userRoutes = [
    {
        path: "/management-team",
        name: "users.management-team",
        component: ManagementTeamList,
        meta: {
            module: MODULES.TEAM,
            menu: {
                parent: 'management-team',
                child: null
            },
            breadcrumb: {
                title: "Équipe de direction",
                nav: {
                    all: {
                        active: "Équipe de direction",
                        inactive: []
                    }
                }
            }
        },
    },
    {
        path: "/profile",
        name: "users.profile",
        component: UserProfile,
        meta: {
            module: MODULES.PROFILE,
            menu: {
                parent: 'profile',
                child: null
            },
            breadcrumb: {
                title: "Mon profil",
                nav: {
                    all: {
                        active: "Mon profil",
                        inactive: []
                    }
                }
            }
        },
    },
    {
        path: "/users/edit/:id",
        name: "users.edit",
        component: UserEdit,
        beforeEnter: adminGuard,
        meta: {
            menu: {
                parent: 'users',
                child: null
            },
            breadcrumb: {
                title: "Utilisateurs",
                nav: {
                    all: {
                        active: "Modification",
                        inactive: [{
                            title: "Tous les utilisateurs",
                            link: {name: 'users.list'}
                        }]
                    }
                }
            }
        },
    },
    {
        path: "/users/create",
        name: "users.create",
        component: UserCreate,
        beforeEnter: adminGuard,
        meta: {
            menu: {
                parent: 'users',
                child: null
            },
            breadcrumb: {
                title: "Utilisateurs",
                nav: {
                    all: {
                        active: "Création",
                        inactive: [{
                            title: "Tous les utilisateurs",
                            link: {name: 'users.list'}
                        }]
                    }
                }
            }
        },
    },
    {
        path: "/users/:id",
        name: "users.show",
        component: UserShow,
        beforeEnter: adminGuard,
        meta: {
            menu: {
                parent: 'users',
                child: null
            },
            breadcrumb: {
                title: "Utilisateurs",
                nav: {
                    all: {
                        active: "Fiche utilisateur",
                        inactive: [{
                            title: "Tous les utilisateurs",
                            link: {name: 'users.list'}
                        }]
                    }
                }
            }
        },
    },
    {
        path: "/users",
        name: "users.list",
        component: UserList,
        beforeEnter: adminGuard,
        meta: {
            menu: {
                parent: 'users',
                child: null
            },
            breadcrumb: {
                title: "Utilisateurs",
                nav: {
                    all: {
                        active: "Tous les utilisateurs",
                        inactive: []
                    }
                }
            }
        },
    }
];
